// extracted by mini-css-extract-plugin
export var header = "_sr-1";
export var maskBottom = "_sr-6";
export var maskMiddle = "_sr-7";
export var maskTop = "_sr-5";
export var root = "_sr-0";
export var scrollDownButton = "_sr-3";
export var scrollDownButtonHidden = "_sr-4";
export var viewport = "_sr-2";